/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
import React, { useEffect, useRef, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { Grid, Paper, TextField, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import CardComponent from './CardComponent';
import RetailAddItem from './RetailAddItem';
import LoadingOverlay from '../components/LoadingOverlay';
import { variables } from '../components/Variables';
import { Navbar } from '../components';

const RetailItemMaster = () => {
  const [loading, setLoading] = useState(false);
  const { activeMenu, RetailCard, setReatilCard, setVendorList } = useStateContext();
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [searchVendor, setSearchVendor] = useState('');
  const [filteredCards, setFilteredCards] = useState(RetailCard || []);
  const isMounted = useRef(false);
  const navigate = useNavigate();
  const userInfo = !!localStorage.getItem('loginID')
    && JSON.parse(localStorage.getItem('loginID'));
  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        getRetailItemData();
        getVendorList();
      }
    }
  }, []);
  useEffect(() => {
    setFilteredCards(RetailCard);
  }, [RetailCard]);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setEditData({});
    setShowModal(false);
  };
  const getRetailItemData = async () => {
    setLoading(true);
    try {
      const data = {
        UserId: userInfo.UserId,
        ProcessName: variables.PROCESSNAME,
        PageName: 'Retail Item Master',
      };

      const response = await axios.post(
        `${variables.BASE_URL}RetailMaster`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const Data = response.data;
      if (Data.IsSuccess && Data.IsAuthorize) {
        const sortedArr = Object.values(
          Data.RetailMaster.reduce((acc, { ID, Vendor, VendorKitItem, item, Qty, UPC, Description }) => {
            if (!acc[ID]) {
              acc[ID] = {
                ID,
                Vendor,
                VendorKitItem,
                UPC,
                Description,
                items: [],
              };
            }
            acc[ID].items.push({ itemId: item, qty: Qty });
            return acc;
          }, {}),
        );
        const sortedData = [...sortedArr].sort((a, b) => a.Vendor.localeCompare(b.Vendor));
        setReatilCard(sortedData);
      } else if (!Data.IsAuthorize) {
        setReatilCard([]);
        setTimeout(() => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Access Denied!',
          });
          navigate('/');
        }, 0);
      } else {
        setReatilCard([]);
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: Data.Reason,
        });
      }
    } catch (error) {
      setReatilCard([]);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error,
      });
    }
    setLoading(false);
  };

  const getVendorList = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${variables.BASE_URL}RetailVendorList`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const Data = response.data;
      if (Data.IsSuccess) {
        const options = Data.retailVendorList.map((item) => ({
          value: item.trim(),
          label: item.trim(), // Remove leading/trailing spaces
        }));
        setVendorList(options);
      } else if (!Data.IsAuthorize) {
        setVendorList([]);
      } else {
        setVendorList([]);
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: Data.Reason,
        });
      }
    } catch (error) {
      setVendorList([]);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error,
      });
    }
    setLoading(false);
  };
  const EditCard = (item) => {
    setEditData(item);
    setShowModal(true);
  };
  const DeleteCard = (item) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to Delete the Kit?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const ReqData = {
          UserId: userInfo.UserId,
          ProcessName: variables.PROCESSNAME,
          PageName: 'Retail Item Master',
          Id: item.ID,
          Vendor: '',
          VendorKitItem: '',
          UPC: '',
          Description: '',
          ActionType: 'DELETE',
          // ActionType: 'INSERT',
          Type_RetailSKUKit_SaveDetails: [],
        };
        try {
          const response = await axios.post(
            `${variables.BASE_URL}RetailSaveData`,
            ReqData,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            },
          );
          const Data = response.data;
          if (Data.IsSuccess) {
            Swal.fire({
              icon: 'success',
              title: 'Done',
              text: Data.Reason,
              allowOutsideClick: false,
            }).then((res) => {
              if (res.isConfirmed) {
                getRetailItemData();
              }
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: Data.Reason,
              allowOutsideClick: false,
            });
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error,
            allowOutsideClick: false,
          });
        } finally {
          setLoading(false);
        }
      }
    });
  };
  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearchVendor(value);
    if (!value.trim()) {
      setFilteredCards(RetailCard); // reset when cleared
    } else {
      const filtered = RetailCard.filter((card) => card.Vendor.toLowerCase().includes(value.toLowerCase().trim()));
      setFilteredCards(filtered);
    }
  };

  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `,
        paddingLeft: `${activeMenu ? '300px' : '0px'}` }}
      >
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full " id="navMenu_id">
          <Navbar />
        </div>
        {loading ? <LoadingOverlay />
          : (
            <div
              style={{ background: 'linear-gradient(135deg,#ecf2ff 10%, #CBDCEB 50%, #ecf2ff 100%)',
                maxHeight: '860px',
                minHeight: '860px',
                overflowY: 'auto',
                border: 'none',
                borderRadius: '15px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  margin: '16px 24px -20px',
                }}
              >
                {/* Left side Search Panel */}
                <Paper
                  className="p-2"
                  elevation={4}
                  style={{
                    borderRadius: '12px',
                    background: '#fff',
                    boxShadow: '8px 8px 16px #bebebe, -8px -8px 16px #ffffff',
                    padding: '10px 24px',
                    minWidth: '400px',
                  }}
                >
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={10}>
                      <TextField
                        autoComplete="off"
                        id="search_vendor"
                        label="Vendor Name"
                        name="VendorName"
                        variant="outlined"
                        size="small"
                        fullWidth
                        placeholder="Search by Vendor Name"
                        value={searchVendor}
                        onChange={handleSearchChange}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon color="action" />
                            </InputAdornment>
                          ),
                          endAdornment: searchVendor && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              edge="end"
                              onClick={() => handleSearchChange({ target: { value: '' } })}
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </Paper>
                {/* Right side */}
                <RetailAddItem
                  getRetailItemData={getRetailItemData}
                  editData={editData}
                  show={showModal}
                  onOpen={handleOpenModal}
                  onClose={handleCloseModal}
                />
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
                  // gap: '20px',
                  padding: '10px',

                }}
              >
                {filteredCards?.map((item) => (
                  <CardComponent
                    key={item.ID}
                    Vendor={item.Vendor}
                    VendorKitItem={item.VendorKitItem}
                    items={item.items}
                    EditCard={() => EditCard(item)}
                    DeleteCard={() => DeleteCard(item)}
                  />
                ))}
              </div>
            </div>
          )}
        <p className="dark:text-gray-500 text-gray-700 text-center ">
          {variables.COPYRIGHT}
        </p>
      </div>

    </div>
  );
};

export default RetailItemMaster;
